/** @module csi/widget/_svg/ImageReplaceLoadingIndicator */
define([
	"dijit/_WidgetBase",
	"dijit/_TemplatedMixin",
	"csi/locale",
	"csi/main",
	"./_Plugin",
	"./PluginFactory"
], function(_WidgetBase, _TemplatedMixin, locale, csi, _Plugin, PluginFactory) {

	return PluginFactory.declare([_WidgetBase, _TemplatedMixin, _Plugin], {
		pluginName: "imageReplaceLoadingIndicator",
		templateString: `
			<span class="dijitInline">
				<span class="csi-flex-row csi-flex-center" style="gap: 4px; padding-left: 2px;">
					<img data-dojo-attach-point="imageNode" height="16px" />
					<span data-dojo-attach-point="labelNode" />
				</span>
			</span>`,

		/**
		 * @override
		 * On lifecycle hook, attach img src and label resource text.
		 */
		postCreate: function() {
			this.imageNode.src = csi.image("logo_loader.gif");
			this.labelNode.appendChild(document.createTextNode(locale.resource("ImageReviewLoading")));
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Determine when to show / hide the widget.
		 */
		canShowPlugin: function() {
			return !this.editor.view._deferredSvg.isResolved();
		},
	});
});
